import { editorNotes } from '@/mocks/home';
import SectionHeading from '@/pages/home/components/SectionHeading';

export default function EditorNotes() {
  const [featured, ...rest] = editorNotes;

  return (
    <section id="editor" className="w-full px-4 py-12 md:px-8 md:py-16">
      <div className="mx-auto max-w-[1280px]">
        <SectionHeading
          kicker="Editor's Desk / 编辑手记"
          index="06 — 编辑部"
          title="我们怎么读这些反差"
          desc="反差内容最容易变成情绪宣泄。编辑部在这里把方法、标准与边界讲清楚，也算是对读者的一个交代。"
          href="#editor"
        />

        <div className="mt-8 grid grid-cols-1 gap-8 lg:grid-cols-[1.15fr_1fr] lg:gap-12">
          <article className="overflow-hidden rounded-lg border border-background-200 bg-background-100">
            <div className="h-[220px] w-full md:h-[300px]">
              <img
                src="https://readdy.ai/api/search-image?query=Editorial%20desk%20still%20life%2C%20vintage%20fountain%20pen%2C%20folded%20newspaper%20columns%2C%20reading%20glasses%20and%20a%20cup%20of%20coffee%20on%20warm%20cream%20textured%20paper%2C%20soft%20window%20light%2C%20muted%20crimson%20and%20gold%20accents%2C%20calm%20sophisticated%20magazine%20workspace%20mood%2C%20artistic%20print%20photography%2C%20no%20text%2C%20no%20people&width=1200&height=800&seq=editor-desk-0910&orientation=landscape"
                alt="编辑部工作台手记配图，报纸与钢笔的静物场景"
                title="黑料反差 - 编辑手记"
                className="h-full w-full object-cover object-top"
              />
            </div>
            <div className="p-6">
              <span className="font-label text-[11px] tracking-widest text-primary-700">{featured.kicker}</span>
              <h3 className="mt-3 font-heading text-xl font-bold leading-snug text-foreground-950 md:text-2xl">
                <a href="#editor" className="transition-colors hover:text-primary-600">
                  {featured.title}
                </a>
              </h3>
              <p className="mt-3 text-sm leading-loose text-foreground-600">{featured.excerpt}</p>
              <div className="mt-5 flex items-center gap-3 border-t border-dashed border-foreground-300 pt-4 font-label text-[11px] text-foreground-500">
                <span>{featured.author}</span>
                <span className="h-3 w-px bg-foreground-300" />
                <span>{featured.date}</span>
                <span className="h-3 w-px bg-foreground-300" />
                <span>阅读约 {featured.readTime}</span>
              </div>
            </div>
          </article>

          <div className="flex flex-col">
            {rest.map((note) => (
              <article
                key={note.id}
                className="border-b border-foreground-950/15 py-6 first:pt-0 last:border-b-0 last:pb-0"
              >
                <span className="font-label text-[11px] tracking-widest text-accent-700">{note.kicker}</span>
                <h3 className="mt-2 font-heading text-lg font-bold leading-snug text-foreground-950 md:text-xl">
                  <a href="#editor" className="transition-colors hover:text-primary-600">
                    {note.title}
                  </a>
                </h3>
                <p className="mt-2 text-sm leading-relaxed text-foreground-600">{note.excerpt}</p>
                <div className="mt-3 flex items-center gap-3 font-label text-[11px] text-foreground-500">
                  <span>{note.author}</span>
                  <span className="h-3 w-px bg-foreground-300" />
                  <span>{note.date}</span>
                  <span className="h-3 w-px bg-foreground-300" />
                  <span>{note.readTime}</span>
                </div>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}